<template>
    <div class="wrap">
        <div class="hd-bg">
            <div class="header">
                <div class="left"><a href="javascript:;" class="btn return" @click="$router.back()"></a></div>
                <div class="right"><a href="javascript:;" class="btn tel" @click="telConfirm"></a><a href="javascript:;" class="btn user" @click="checkLogined"></a></div>
                <div class="center">全部户型</div>
                <!-- <div class="center"><router-link to="/">全部户型</router-link></div> -->
            </div>
        </div>
        <div class="top">
            <div class="item" @click="nindexchange(1)" :class="{active:nindex==1}"><span>全部(12)</span></div>
            <div class="item" @click="nindexchange(2)" :class="{active:nindex==2}"><span>500m²以下</span></div>
            <div class="item" @click="nindexchange(3)" :class="{active:nindex==3}"><span>500-1000m²</span></div>
            <div class="item" @click="nindexchange(4)" :class="{active:nindex==4}"><span>1000m²</span></div>
        </div>
        <div class="main-wrap">
            <div class="sidebar">
                <div class="item" @click="sidechange(1)" :class="{active:sidei==1}">
                    在售（12）
                </div>
                <div class="item" @click="sidechange(2)" :class="{active:sidei==2}">
                    在租（0）
                </div>
            </div>
            <div class="content">
                <div class="item">
                    <div class="left">

                    </div>
                    <div class="right">
                        <div class="title">
                            1号楼标准户型
                        </div>
                        <div class="desc">建筑面积约2000平米</div>
                        <div class="status">在售</div>
                    </div>
                </div>
                <div class="item">
                    <div class="left">

                    </div>
                    <div class="right">
                        <div class="title">
                            1号楼标准户型
                        </div>
                        <div class="desc">建筑面积约2000平米</div>
                        <div class="status">在售</div>
                    </div>
                </div>
                <div class="item">
                    <div class="left">

                    </div>
                    <div class="right">
                        <div class="title">
                            1号楼标准户型
                        </div>
                        <div class="desc">建筑面积约2000平米</div>
                        <div class="status">在售</div>
                    </div>
                </div>
                <div class="item">
                    <div class="left">

                    </div>
                    <div class="right">
                        <div class="title">
                            1号楼标准户型
                        </div>
                        <div class="desc">建筑面积约2000平米</div>
                        <div class="status">在售</div>
                    </div>
                </div>
                <div class="item">
                    <div class="left">

                    </div>
                    <div class="right">
                        <div class="title">
                            1号楼标准户型
                        </div>
                        <div class="desc">建筑面积约2000平米</div>
                        <div class="status">在售</div>
                    </div>
                </div>
                <div class="item">
                    <div class="left">

                    </div>
                    <div class="right">
                        <div class="title">
                            1号楼标准户型
                        </div>
                        <div class="desc">建筑面积约2000平米</div>
                        <div class="status">在售</div>
                    </div>
                </div>
                <div class="item">
                    <div class="left">

                    </div>
                    <div class="right">
                        <div class="title">
                            1号楼标准户型
                        </div>
                        <div class="desc">建筑面积约2000平米</div>
                        <div class="status">在售</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">
            <div>
                    <div class="footer-tel">客服电话 | 400-0080-960</div>
                    <div class="footer-copy">
                        <p>© 2016-2018 选址中国控股有限公司</p>
                        <p>京ICP备16020840号</p>
                    </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { Dialog } from 'vant'
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import { SwipeCell, Toast, List } from 'vant'

    export default {
        name: "alltype",
        data: function () {
            return {
                nindex:1,
                sidei:1
            }
        },
        components: {
            Header,
            [Dialog.name]: Dialog
        },
        mounted(){
            
        },
        methods: {
            sidechange(val){
                this.sidei=val
            },
            nindexchange(val){
                this.nindex=val
            },
            checkLogined () {
                var _this = this;
                _this.api.getUserInfo().then(function(response){
                    if (response.status == 1) {
                        _this.$router.push('UserCenter')
                    } else {
                        _this.$router.push('Login')
                    }
                })
            },
            telConfirm () {
                Dialog.confirm({
                    title: '400转接',
                    message: '',
                    confirmButtonText: '确定'
                }).then(() => {
                    window.location.href = "tel:4000080960";
                }).catch(()=>{});
            }
          
          
        }
    }
</script>
<style lang="scss" scoped>
    @import "./common.scss";
    .hd-bg {height: 1rem;}

    .header {
        position: fixed;top: 0;left: 0;width: 100%;height: 1rem;z-index: 100;
        background-color: #343434;line-height: 1rem;text-align: center;
    }
    .header .btn {
        display: inline-block;vertical-align: middle;width: .36rem;height: .36rem;margin: 0 .15rem;
        background-repeat: no-repeat;background-position: center center;-webkit-background-size: contain;background-size: contain;
    }
    .header .return {background-image: url('../assets/images/icon-return.png');}
    .header .user {background-image: url('../assets/images/icon-head-user.png');}
    .header .tel {background-image: url('../assets/images/icon-head-tel.png');}
    .header .left {
        position: absolute;top: 0;left: .15rem;
    }
    .header .right {
        position: absolute;top: 0;right: .15rem;
    }
    .header .center {
        position: relative;
        display: inline-block;
        font-size: .36rem;color: #ffffff;
    }
    .header .city {
        position: absolute;left: 100%;top: 50%;margin: -.7em .1rem 0;
        white-space: nowrap;font-size: .6em;line-height: 2;
        padding-right: .2rem;background: url("../assets/images/icon-sel3.png") no-repeat right center;-webkit-background-size: .15rem;background-size: .15rem;
    }
     .footer {
         position:absolute;
         bottom:0;
        width: 100%; 
        background-color: #343434;
        text-align: center;
        height:2rem;
        display:flex;
        align-items: center;
        justify-content: center;
    }
    .footer-tel {
        font-size: .22rem;color: #ffffff;
    }
    .footer-copy {
        font-size: .18rem;color: #ffffff;
    }
    .content .status{
        width:px2rem(28px);
        height:px2rem(16px);
        justify-content: center;
        align-items: center;
        background:#ff0000;
        color:#fff;
        display: flex;
        font-size:px2rem(8.42px);
    }
    .content .title{
        font-weight:bold;
        font-size:px2rem(12.69px);
    }
    .content .desc{
        padding:px2rem(6px) 0;
        font-size:px2rem(9.6px);
        color:#888d90;
    }
    .content .item{
        margin:px2rem(10px) 0 px2rem(10px) 0;
        display:flex;
    }
    .content .left{
        border:px2rem(1px) solid #e6e6e6;
        width:px2rem(69.67px);
        height:px2rem(61.33px);
        margin-right:px2rem(10px);
    }
    .sidebar .active{
       background:#fff;
       color:#6da3eb;
    }
    .sidebar .item{
        font-size:px2rem(10.1px);
        width:px2rem(69.67px);
        height:px2rem(52.33px);
        display:flex;
        align-items: center;
        justify-content: center;
    }
    .main-wrap .content{
        position:absolute;
        left:px2rem(87.67px);
        right:0;
        top:0rem;
        bottom:0rem;
        overflow: auto;
    }
    .wrap{
        position:relative;
        min-height:100%;
    }
    .sidebar{
        position:absolute;
        left:0;
        bottom:0rem;
        top:0rem;
        background:#f3f5fb;
    }
    .top{
        padding-left:px2rem(14px) ;
        position:absolute;
        top:1rem;
        right:0;
        left:0;
        height:1.4rem;
        align-items: center;
        display:flex;
    }
    .top .item{
        position:relative;
        width:px2rem(80px);
        font-size:px2rem(10px)
    }
    .top span{
        position:relative;
    }
    .main-wrap{
        width:100%;
        position:absolute;
        top:2.4rem;
        bottom:2rem;
        display:flex;
    }
    .top .active{
        color:#6da3eb
    }
    .top .active span:after{
       height:px2rem(1px);
       width:px2rem(12px);
       content:'';
       position:absolute;
       background:#6da3eb;
       bottom:px2rem(-2px);
       left:50%;
       margin-left:px2rem(-6px)
    }
</style>